module.exports = __webpack_public_path__ + "static/media/jarredHeadshot.80eca619.png";